import Alert from "../../Alert/Alert"
import { AddWorkflowFormProps } from "./AddPatchScopeWorkflowForm.types"
import Button from "../../Button/Button"
import PlusIcon from "../../../media/PlusIcon"
import ScopeWorkflowFormType from "../../../utils/ScopeWorkflowFormType"
import usePatchAddWorkflow from "./usePatchAddWorkflow"
import "./AddPatchWorkflowForm.css"
import SkeletonLoadingView from "../../SkeletonLoadingView/SkeletonLoadingView"

const AddPatchWorkflowForm = (props: AddWorkflowFormProps) => {

  const { showForm, onHide, formType } = props

  const [{
    scopeWorkflow,
    currentForm,
    forms,
    currentFormIndex,
    onSelectForm,
    onNext
  }] = usePatchAddWorkflow(props)

  return (
    <Alert showAlert={showForm} onClose={onHide}>
      <div className="add-workflow-form-container">
        <div>
          <h2 className="add-workflow-form-title">Create Patch Workflow Scope</h2>
          <div className="scope-workflow-header">
            <div className="scope-workflow-breadcrumbs">
              {forms.map((form, index) => (
                <>
                  {index <= currentFormIndex && (
                    <p
                      key={index}
                      onClick={() => onSelectForm(index)}
                    >
                      {`${form}/`}
                    </p>
                  )}
                </>
              ))}
            </div>
            <div className="close-icon" onClick={onHide}>
              <PlusIcon />
            </div>
          </div>
        </div>
        
        {scopeWorkflow.status === "loading" ? (
          <SkeletonLoadingView style={{height: "30em"}} />
        ) : (
          <>
            {currentForm}
          </>
        )}

        {currentFormIndex === forms.length-1 ? (
          <>
            {formType === ScopeWorkflowFormType.ADD && (
              <Button className="next-scope-form-button" type="full" title="Add" onClick={onNext} />
            )}

            {formType === ScopeWorkflowFormType.VIEW && (
              <Button className="next-scope-form-button" type="full" title="Done" onClick={onNext} />
            )}

            {formType === ScopeWorkflowFormType.EDIT && (
              <Button className="next-scope-form-button" type="full" title="Edit" onClick={onNext} />
            )}
          </>
        ) : (
          <Button className="next-scope-form-button" type="full" title="Next" onClick={onNext} />
        )}
        
      </div>
    </Alert>
  )
}

export default AddPatchWorkflowForm;